import { render, staticRenderFns } from "./sending-group-sms.vue?vue&type=template&id=2361c2a5"
import script from "./sending-group-sms.vue?vue&type=script&lang=js"
export * from "./sending-group-sms.vue?vue&type=script&lang=js"
import style0 from "./sending-group-sms.vue?vue&type=style&index=0&id=2361c2a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports